import React from "react";
import { SpaceShape } from "venuescanner-js/react/shapes";

const getContent = (responseTime) => {
  if (responseTime > 36 || responseTime <= 0) return null;
  const responsePrompt =
    responseTime < 12 ? <>Super speedy response</> : "Fast response";
  return (
    <>
      <span>{responsePrompt}</span>
    </>
  );
};

const ResponseTime = ({ space }) => (
  <div className="space-tile__review--response-time">
    {getContent(space.owner_avg_response)}
  </div>
);

ResponseTime.propTypes = {
  space: SpaceShape.isRequired,
};

export default ResponseTime;
